import React from 'react';
import { AiOutlineTrophy } from 'react-icons/ai';
import { Link } from 'react-router-dom';
import defaultImage from '@/assets/images/placeholders/show-course.jpg';
import { StarRatingStatic } from '@/components/custom/star-rating';
import { Badge } from '@/components/ui/badge';

export default function RecommendedCourseCard() {
  return (
    <div className="recommended-course-card">
      <div className="recommended-course-card__img-wrapper">
        <img
          className="recommended-course-card__img"
          src={defaultImage}
          alt=""
        />
      </div>

      <div className="recommended-course-card__container">
        <div className="recommended-course-card__header">
          <span className="badge badge--primary">Tecnologia</span>
        </div>

        <div className="recommended-course-card__body">
          <div className="recommended-course-card__infos">
            <h3 className="recommended-course-card__title">Desenvolvimento de Games em VR e AR para usuários com baixa visão</h3>
            <div className="mb-4">
              <StarRatingStatic
                rating={4}
                className="w-[100px]"
              />
            </div>
            <div className="mb-4">
              <Badge
                variant="success"
                square
                className="px-2"
              >
                <AiOutlineTrophy /> Certificado Online
              </Badge>
            </div>
            <Link
              className="btn btn--small btn--wide btn--outline-white"
              to={`/curso/${1}`}
            >
              Visualizar
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
